<template>
  <div class="adress">
    <div class="adress_tit">
      新增收货地址
    </div>
    <!-- 新增收货地址 -->
    <div class="adress_from">
      <div class="adress_item">
        <div class="adress_name">收货人</div>
        <div class="adress_input">
          <input type="text" v-model="editaddressarr.name" @blur="inputname" placeholder="请填写姓名(必填)">
        </div>
      </div>
      <div class="adress_item">
        <div class="adress_name">电话号码</div>
        <div class="adress_input">
          <input type="text" v-model="editaddressarr.phone" @blur="inputphone" placeholder="请填写姓名(必填)" maxlength="11">
        </div>
      </div>
      <div class="adress_item">
        <div class="adress_name">所在地区</div>
        <div class="adress_input">
          <el-cascader size="large" :options="options" v-model="editaddressarr.areaarr" @change="handleChange">
          </el-cascader>
        </div>
      </div>
      <div class="adress_item">
        <div class="adress_name">详细地址</div>
        <div class="adress_textarea">
          <textarea v-model="editaddressarr.address" @blur="inputaddress" id="" cols="30" rows="10"></textarea>
        </div>
      </div>
      <div class="adress_items">
        设为默认地址
        <el-switch class="adress_off" v-model="editaddressarr.checked" @change="checkedfn" active-color="#ff4949" inactive-color="#BFBFBF">
        </el-switch>
      </div>
      <div class="adress_btns">
        <div class="adress_btn" @click="editfn()">
          保存
        </div>
      </div>
    </div>
    <!-- 已有的收货地址 -->
    <div class="adress_tit">
      已有的收货地址
    </div>
    <!-- 收货地址 -->
    <table class="adress_table">
      <tr class="adress_table1">
        <td> 收货人 </td>
        <td> 所在地区 </td>
        <td> 详细地址 </td>
        <td> 电话 </td>
        <td> 操作 </td>
        <td> {{addressarr.length}}</td>
      </tr>
      <tr class="adress_table3" v-if="addressarr.length==0">
        <td colspan="6">没有地址</td>
      </tr>
      <tr class="adress_table2" v-else v-for="(item,index) in addressarr" :key="index">
        <td> {{item.name}} </td>
        <td>
          {{item.area}}
        </td>
        <td> {{item.address}}</td>
        <td> {{item.phone}} </td>
        <td>
          <div class="edit" @click="editaddressfn(item)">
            修改
          </div>|
          <div class="del" @click="deladdressfn(item.id)">
            删除
          </div>
        </td>
        <td>
         <div class="default_active" v-if="item.is_default==1">
           默认地址
         </div>
         </td>
      </tr>
    </table>

  </div>
</template>

<script>
  import {
    regionData,
    CodeToText,
    TextToCode
  } from 'element-china-area-data'
  import {getaddressapi,editaddressapi,deladdressapi} from "../../../api/http.js"
  export default {
    name: 'adress',
    data() {
      return {
        options: regionData,
        editaddressarr:{
          id:"",
          address: "",
          area: "",
          areaarr:"",
          checked: true,
          is_default: 1,
          name: "",
          phone: "",
        },
        addressarr:[]
      }
    },
    created() {
      this._getaddress()
    },
    methods: {
    // 保存
   async editfn(){
        var namereg = /^[\u4e00-\u9fa5]+$/
        var phonereg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/
        var addressreg = /^[^ ]/
        if (this.editaddressarr.name == "" || !namereg.test(this.editaddressarr.name)) {
          return this.$message("输入正确的姓名")
        }
        if (this.editaddressarr.phone == "" || !phonereg.test(this.editaddressarr.phone)) {
          return this.$message("输入正确的手机号码")
        }

        if (this.editaddressarr.area == "") {
          return this.$message("请选择正确的地址")
        }
        if (this.editaddressarr.address == "" || !addressreg.test(this.editaddressarr.address)) {
          return this.$message("输入正确的详细地址")
        }
        const res = await editaddressapi(this.editaddressarr)
        if (res.data.code==200) {
            this.$message("保存成功")
        } else{
            this.$message("保存失败")
        }

        this._getaddress()
        this.editaddressarr={}
    },
      //获取收货地址
    async _getaddress(){
        var _that = this
        const res = await getaddressapi()
        if(res.data.code==200){
          if (res.data.data.length>0) {
            for (var i = 0; i < res.data.data.length; i++) {
              res.data.data[i].checked = res.data.data[i].is_default==1?true:false;
              console.log(res.data.data[i].area);
              res.data.data[i].areaarr =TextToCode[res.data.data[i].area.split("/")[0]][res.data.data[i].area.split("/")[1]][res.data.data[i].area.split("/")[2]].code
            }
            console.log(res.data.data);
            _that.addressarr = res.data.data
          }
        }else{
          _that.addressarr = []
        }
      },
      // 删除收货地址
     async deladdressfn(id){
      const res = await deladdressapi({id:id})
      if (res.data.code==200) {
        this.$message("删除成功")
        this.editaddressarr={}
        this._getaddress()
      } else{
        this.$message("删除失败")
      }
     },
     // 修改地址
     editaddressfn(item){
      this.editaddressarr=item
     },
     // 收货人
     inputname(){
        var namereg = /^[\u4e00-\u9fa5]+$/
        namereg.test(this.editaddressarr.name) ? this.$message("姓名输入正确") : this.$message("输入正确的姓名")
     },
     // 电话号码
     inputphone(){
        var phonereg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/
        phonereg.test(this.editaddressarr.phone) ? this.$message("手机号输入正确") : this.$message("请输入正确的手机号")
     },
     // 详细地址
     inputaddress(){
      var addressreg = /^[^ ]/
      addressreg.test(this.editaddressarr.address) ? this.$message("详细地址输入正确的") : this.$message("输入正确的详细地址")
     },
     // 默认地址
     checkedfn(){
        this.editaddressarr.checked?this.editaddressarr.is_default=1:this.editaddressarr.is_default=0
     },
     // 所在地区
    handleChange(value) {

      this.editaddressarr.area=CodeToText[value[0]] + '/' + CodeToText[value[1]] + '/' + CodeToText[value[2]]
      console.log(this.editaddressarr.area);
    }

    }
  }
</script>

<style lang="less">
  .adress {
    width: 100%;
    .adress_from {
      width: 100%;
      padding: 50px 70px;
      box-sizing: border-box;
      border: 1px solid #CCCDCE;
      margin-bottom: 20px;

      .adress_btns {
        width: 100%;
        height: 40px;
        padding-left: 270px;
        box-sizing: border-box;
        margin-top: 40px;

        .adress_btn {
          width: 125px;
          height: 40px;
          background: #FF4444;
          border-radius: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .adress_items {
        font-size: 12px;
        padding-left: 100px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .adress_off {
          margin-left: 20px;
        }
      }

      .adress_item {
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        .adress_name {
          color: #292929;
          width: 100px;
        }

        .adress_input {
          width: 340px;
          height: 36px;
          border: 1px solid #CCCDCE;

          input {
            width: 340px;
            height: 36px;
            border: none;
            outline: none;
            background-color: transparent;
            text-indent: 2em;
          }
        }

        .adress_textarea {
          width: 340px;
          height: 80px;
          border: 1px solid #CCCDCE;
          padding: 10px;
          box-sizing: border-box;

          textarea {
            width: 100%;
            height: 60px;
            border: none;
            outline: none;
            resize: none;
            background-color: transparent;
          }
        }
      }
    }

    .adress_table {
      width: 100%;
      border: 1px solid #CCCDCE;
      font-size: 14px;

      .adress_table1 {
        text-align: center;
      }

      .adress_table2 {
        text-align: center;
        .edit{
          display: inline-block;
          margin-right: 10px;
        }
        .del{
          display: inline-block;
          margin-left: 10px;
        }
        td {
          div:hover{
            color: #FF4444;
            cursor: pointer;
          }
          .default_active{
            font-size: 12px;
            color: #FF4444;
            display: inline-block;
            padding: 10px 20px;
            background: #FFFFFF;
            border: 1px solid #FF4444;
          }

        }
      }
      .adress_table3{
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
      }
      tr {
        border: 1px solid #CCCDCE;
        td {
          padding: 20px 10px;
          box-sizing: border-box;
          text-align: center;
          width: 16%;
          border: 1px solid #CCCDCE;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/view/adress.vue